import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Button } from '@miro-site/core';
import styled, { css } from 'styled-components';
var SecondaryLink = styled(Button).withConfig({
  displayName: "SecondaryLink",
  componentId: "sc-1nlhjcz-0"
})(["", " ", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.normalizeStyles({
    color: theme.templates.colors.secondary40,
    ':focus': _objectSpread({}, theme.focus.outlines.withOffset),
    fontSize: 14,
    lineHeight: 20
  });
}, function (_ref2) {
  var $isDashed = _ref2.$isDashed;
  return $isDashed ? css(["border-bottom:1px dashed currentColor;transition:border-color 250ms ease 0s;&:hover{border-color:transparent;}"]) : css(["border-color:transparent;&:hover{border-color:transparent;}"]);
});
export default SecondaryLink;